jQuery(document).ready(function ($) {
	if ($("body").hasClass("post-type-archive-team")) {
		const teamMemberRow = document.getElementById("team_member_row");

		let filters = {
			category: "",
			fund: "",
			location: "",
			search: "",
		};

		$("#teamsearch").on("input", function () {
			filters.search = $(this).val().toLowerCase();
			sendAjaxRequest(filters);
		});

		$("#filters #view_all, #reset_filters").on("click keypress", function (e) {
			if (e.type == "click" || e.key == "Enter") {
				emptyObject(filters);
				resetDropdowns();
				filters.search = "";
				$("#teamsearch").val("");
				sendAjaxRequest(filters);
			}
		});

		$(".select-dropdown .options .link").on("click", (e) => {
			const target = $(e.target);
			const targetSelect = target.data("select");
			const filter = getFilterKey(
				target.closest(".select-dropdown").attr("id")
			);

			targetSelect.substring(0, 3) == "all"
				? selectAllInDropdown(filter)
				: setFilter(filter, targetSelect, checkActive(target));

			sendAjaxRequest(filters);
		});

		function setFilter(filterKey, selected, isActive) {
			isActive ? (filters[filterKey] = selected) : (filters[filterKey] = "");
		}

		function selectAllInDropdown(objectKey) {
			filters[objectKey] = "";
		}

		function sendAjaxRequest(filters) {
			// console.log("function sendAjaxRequest(filters)");

			$.ajax({
				url: ajax_url,
				type: "post",
				dataType: "json",
				data: {
					action: "archive_filter_team",
					post_type: "team",
					filters: filters ? filters : null,
				},
				success: ({ blog_data } = res) => {
					teamMemberRow.innerHTML = "";

					if (blog_data) {
						let counter = 0;

						for (result of blog_data) {
							// Check if the search term matches the team member's title
							if (
								!filters.search ||
								result.title.toLowerCase().includes(filters.search)
							) {
								teamMemberRow.innerHTML += team_member_html(result);
							} else {
								// For each result that does not match the search, increase the counter
								counter++;
								/* Do not try this at home... */
							}
						}

						if (counter === blog_data.length) {
							// No Result Found
							teamMemberRow.innerHTML = `<div id="noresult" class="col-lg-8">
									<h2>NO RESULTS FOUND</h2>
									<p>Please try another search, or reset the filters below.</p>
									<a id="reset_filters" href="javascript:;" class="button">Reset filters</a>
								</div>`;
						}
					}

					toggleShowResults(teamMemberRow, blog_data ? "show" : "hide");
				},

				error: function (xhr, status, error) {
					console.error(xhr.responseText);
				},
			});
		}

		function team_member_html({ thumbnail, title, role, permalink } = post) {
			return `<article class="team-member col-xxl-2 col-xl-3 col-md-4 col-6">
						<a href="${permalink}" class="content is-link">
							<div class="image_container">
								<img width="286" height="286" src="${thumbnail}" sizes="(max-width: 286px) 100vw, 286px" alt="">
							</div>
							<div class="text-box">
								<h2 class="title">${title}</h2>
								<p class="role"><${role}</p>
								<div class="bottom-row">
								<div class="link"><span>Read&nbsp;bio</span><img src="${homeUrl}/wp-content/themes/Endless23/assets/Icons/Right-Arrow-Icon-Orange.svg" alt=""></div>
								</div>
							</div>
						</a>
					</article>`;
		}
	}

	if ($("body").hasClass("single-team")) {
		// add the post title to the form, without using a custom wpcf7 tag
		$("#form-post-title").val($(".post-title").text());
	}
});
